module.exports = __webpack_public_path__ + "media/images/gear-781641578bc424cbb6b16a4f47234b0b.svg";